import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ReportService } from 'services';

interface Props {
	onClose?: any;
}

class ModalSettings extends React.Component<Props> {

	state = {
		form: {
			points_quantity: ''
		},
		points_levels: [],
		points_by_payments: []
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await ReportService.admin.getSettings();
		this.setState({
			form: {
				points_quantity: res.points_quantity || 1
			},
			points_levels: res.points_levels || [],
			points_by_payments: res.points_by_payments || [],
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		const points_by_payments = this.state.points_by_payments.find((i: any) => !i.prepaid || !i.on_time);

		if (points_by_payments) {
			Globals.showError("Por favor, ingrese todos los valores para continuar");
			return;
		}

		const points_level = this.state.points_levels.find((i: any) => !i.max_points || !i?.limits?.find((i: any) => i.currency_id == Constants.CURRENCIES.USD)?.amount || !i?.limits?.find((i: any) => i.currency_id == Constants.CURRENCIES.COP)?.amount);

		if (points_level) {
			Globals.showError("Por favor, ingrese todos los valores para continuar");
			return;
		}

		await ReportService.admin.saveSettings({
			...this.state.form,
			points_levels: JSON.stringify(this.state.points_levels),
			points_by_payments: JSON.stringify(this.state.points_by_payments)
		});
		Globals.showSuccess("Se ha actualizado la configuración correctamente");
		this.props.onClose();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	changePoints = (e: any,index: number,callback = () => {}) => {
		let points_by_payments: any = [...this.state.points_by_payments];
		points_by_payments[index][e.target.name] = e.target.value;
		this.setState({
			points_by_payments
		},callback);
	}

	changeLevel = (e: any,index: number,callback = () => {}) => {
		let points_levels: any = [...this.state.points_levels];
		points_levels[index][e.target.name] = e.target.value;
		this.setState({
			points_levels
		},callback);
	}

	changeLevelLimit = (e: any,index: number,currency_id: number,callback = () => {}) => {
		let points_levels: any = [...this.state.points_levels];
		const _index = points_levels[index].limits?.findIndex((i: any) => i.currency_id == currency_id);
		points_levels[index].limits[_index].amount = e.target.value;
		this.setState({
			points_levels
		},callback);
	}
	
	render() {
		const { points_by_payments } = this.state;

		return (
			<div id="modal-points-settings">
				<form onSubmit={ this.submit }>
					<div className="row">
						{
							points_by_payments?.map((item: any, index: number) => {
								return (
									<>
										<div className="col-md-6">
											<Input
												type="number"
												value={ item.prepaid }
												name="prepaid"
												placeholder="0"
												label={ `Puntos por pago adelantado (${ item?.modality?.name || '' })` }
												onChange={ (e: any) => this.changePoints(e,index) } />
										</div>
										<div className="col-md-6">
											<Input
												type="number"
												value={ item.on_time }
												name="on_time"
												placeholder="0"
												label={ `Puntos por pago a tiempo (${ item?.modality?.name || '' })` }
												onChange={ (e: any) => this.changePoints(e,index) } />
										</div>
									</>
								)
							})
						}
						<div className="col-md-6">
							<Input
								type="number"
								value={ this.state.form.points_quantity }
								name="points_quantity"
								placeholder="0"
								label="Puntos cada X pesos colombianos"
								onChange={ (e: any) => this.change(e) } />
						</div>
					</div>
					{
						this.state.points_levels.map((item: any,index: number) => {
							return (
								<div className="row row-levels">
									<div className="col-md-2">
										<p>Nivel { item.level }</p>
									</div>
									<div className="col-md">
										<Input
											type="number"
											value={ item.max_points }
											name="max_points"
											placeholder="0"
											label="Hasta (puntos)"
											onChange={ (e: any) => this.changeLevel(e,index) } />
									</div>
									<div className="col-md">
										<Input
											type="decimal"
											value={ item?.limits?.find((i: any) => i.currency_id == Constants.CURRENCIES.USD)?.amount }
											name="amount"
											placeholder="0"
											label="Limite ($/€)"
											onChange={ (e: any) => this.changeLevelLimit(e,index,Constants.CURRENCIES.USD) } />
									</div>
									<div className="col-md">
										<Input
											type="decimal"
											value={ item?.limits?.find((i: any) => i.currency_id == Constants.CURRENCIES.COP)?.amount }
											name="amount"
											placeholder="0"
											label="Limite (COP)"
											onChange={ (e: any) => this.changeLevelLimit(e,index,Constants.CURRENCIES.COP) } />
									</div>
								</div>
							)
						})
					}
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalSettings;